/* tslint:disable */
/* eslint-disable */
/**
 * Accounts API
 * API pour la gestion des comptes utilisateurs
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface ConnectedUserInfosResponse
 */
export interface ConnectedUserInfosResponse {
    /**
     * Désignation de l'entité légale
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    legalEntity: string;
    /**
     * Nom de famille
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    lastName: string;
    /**
     * Prénom
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    firstName: string;
    /**
     * Nom d'utilisateur
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    userName: string;
    /**
     * Adresse email
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    email: string;
    /**
     * Numéro de téléphone
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    phone: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof ConnectedUserInfosResponse
     */
    address: AddressDto;
    /**
     * Plateforme courante
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    currentPlateforme: string;
    /**
     * Numéro SIRET
     * @type {string}
     * @memberof ConnectedUserInfosResponse
     */
    siret: string;
}

/**
 * Check if a given object implements the ConnectedUserInfosResponse interface.
 */
export function instanceOfConnectedUserInfosResponse(value: object): value is ConnectedUserInfosResponse {
    if (!('legalEntity' in value) || value['legalEntity'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('currentPlateforme' in value) || value['currentPlateforme'] === undefined) return false;
    if (!('siret' in value) || value['siret'] === undefined) return false;
    return true;
}

export function ConnectedUserInfosResponseFromJSON(json: any): ConnectedUserInfosResponse {
    return ConnectedUserInfosResponseFromJSONTyped(json, false);
}

export function ConnectedUserInfosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectedUserInfosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntity': json['legalEntity'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'userName': json['userName'],
        'email': json['email'],
        'phone': json['phone'],
        'address': AddressDtoFromJSON(json['address']),
        'currentPlateforme': json['currentPlateforme'],
        'siret': json['siret'],
    };
}

export function ConnectedUserInfosResponseToJSON(json: any): ConnectedUserInfosResponse {
    return ConnectedUserInfosResponseToJSONTyped(json, false);
}

export function ConnectedUserInfosResponseToJSONTyped(value?: ConnectedUserInfosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'legalEntity': value['legalEntity'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'userName': value['userName'],
        'email': value['email'],
        'phone': value['phone'],
        'address': AddressDtoToJSON(value['address']),
        'currentPlateforme': value['currentPlateforme'],
        'siret': value['siret'],
    };
}

